import { RotatorCampaignIdSchema as i } from "@hprofits/shared";
import { z as e } from "zod";
import { PricingRuleIdParamSchema as r, RotatorCampaignIdParamSchema as l } from "../common/params.js";
const u = [1, 2], n = e.union([e.literal(1), e.literal(2)]).nullable(), m = ["geo", "trained", "training", "mixed", "goals", "goals_mixed"], c = e.enum(m), t = e.number().nonnegative().nullable(), a = e.object({
  model: c.nullable(),
  ctrMultiplier: t,
  customScoreMultiplier: t,
  mGlobal: t,
  kGeo: t,
  expLambda: t,
  ignoreKeywords: e.boolean(),
  useImgCtr: e.boolean()
}).readonly(), o = e.object({
  interval: e.int().positive(),
  count: e.int().positive()
}).readonly(), d = a.unwrap().extend({ model: e.string().nullable() }).readonly(), s = e.object({
  id: i,
  experimentId: n,
  settings: d,
  capping: o.nullable(),
  editable: e.boolean(),
  createdAt: e.string(),
  updatedAt: e.string()
}).readonly(), S = e.object({
  rotatorIndex: e.string().nullable(),
  items: e.array(s).readonly()
}).readonly(), R = r.extend({
  experimentId: n,
  settings: a,
  capping: o.nullable()
}).readonly(), h = l.extend({
  settings: a,
  capping: o.nullable()
}).readonly();
export {
  R as CreateRotatorCampaignSchema,
  u as ROTATOR_EXPERIMENT_IDS,
  m as ROTATOR_MODELS,
  o as RotatorCampaignCappingSchema,
  S as RotatorCampaignListSchema,
  s as RotatorCampaignSchema,
  a as RotatorCampaignSettingsSchema,
  d as RotatorCampaignStoredSettingsSchema,
  n as RotatorExperimentIdSchema,
  c as RotatorModelSchema,
  h as UpdateRotatorCampaignSchema
};
//# sourceMappingURL=schemas.js.map
